import { useState } from "react";
import "./AccordionSection.css";
import AccordionItem from "./AccordionItem";

import immersiveImg from "../../assets/images/immersive.png";
import barriersImg from "../../assets/images/barriers.png";
import breaksImg from "../../assets/images/breaks.png";

function AccordionSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const accordionData = [
    {
      number: "01",
      title: "Immersive Technology",
      text: `Artoreal is powered by immersive technology that harnesses the power of AI, AR & VR and Emotional Analytics to help one find the desired framed artwork for your home.`,
      image: immersiveImg,
    },

    {
      number: "02",
      title: "Barriers Disconnecting Makers of Art from Buyers of Art",
      text: `Following barriers create the distance between buyers and sellers of art.`,
      image: barriersImg,
    },

    {
      number: "03",
      title: "Artoreal Breaks Barriers",
      text: `This is how Artoreal creates a seamless digital commerce experience for Art.`,
      image: breaksImg,
    },
  ];

  return (
    <section className="accordion-section">
      <div className="accordion-left">
        <h2>
          Re-imagining
          <br />
          the <span>Art Ecosystem</span>
        </h2>

        <p>
          The fundamental premise of Artoreal is to bridge artists,
          buyers, galleries and printing-framing-delivery service
          providers while delivering a superior digital experience.
        </p>
        <p>
          Artoreal does this by offering a wide online selection
          of art, affordable pricing and immersive technology
          that makes selecting and buying art simple and
          intelligent.
        </p>
      </div>

      <div className="accordion-right">
        {accordionData.map((item, index) => (
          <AccordionItem
            key={index}
            number={item.number}
            title={item.title}
            text={item.text}
            image={item.image}
            isOpen={openIndex === index}
            onClick={() =>
              setOpenIndex(
                openIndex === index ? null : index
              )
            }
          />
        ))}
      </div>
    </section>
  );
}

export default AccordionSection;